export default __webpack_public_path__ + "static/media/video-bg.32baf23c.png";